<template>
  <div>
    <v-container class="py-10" id="cloud">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <div class="subtitle" style="color:#0391af">Chancen</div>
          <h2>61. Datennutzung</h2>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
          <v-btn icon aria-hidden="true">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" aria-hidden="true">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="download('image/jpeg')">
                <v-list-item-content>
                  <v-list-item-title>JPEG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="download('image/svg+xml')">
                <v-list-item-content>
                  <v-list-item-title>SVG herunterladen</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            icon
            aria-hidden="true"
            :to="{
              name: 'comparison',
              query: { var: 'konkrete Herausforderungen' }
            }"
          >
            <v-icon>mdi-chart-line</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "A055",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "line"
        },
        title: {
          text: "Nutzung von Daten für eine evidenzbasierte Strategie."
        },
        xAxis: {
          categories: [
            "Trifft überhaupt nicht zu",
            "Trifft eher nicht zu",
            "Trifft teilweise zu",
            "Trifft eher zu",
            "Trifft voll zu"
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: "Meine Organisation hat eine klare Strategie.",
            data: [2.0, 7.7, 18.4, 33.8, 38.1]
          },
          {
            name:
              "Wir erheben selbst Daten und/oder nutzen Daten aus fremden Quellen zur Entwicklung unserer Strategie.​",
            data: [21.5, 21.4, 19.6, 22.7, 14.8]
          },
          {
            name: "Wir messen unsere soziale Wirkung.",
            data: [26.3, 24.3, 21.0, 17.9, 10.5]
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
